var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_280_6660)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.37207,
    y: 0.452148,
    width: 23.2833,
    height: 24.6783,
    rx: 10,
    fill: "#F4F7FE"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_280_6660)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6168 13.7331H11.8168C12.5868 13.7331 13.2168 14.3631 13.2168 15.1331V22.1331C13.2168 22.9031 12.5868 23.5331 11.8168 23.5331H11.6168C10.8468 23.5331 10.2168 22.9031 10.2168 22.1331V15.1331C10.2168 14.3631 10.8468 13.7331 11.6168 13.7331ZM17.2168 9.53308C17.9868 9.53308 18.6168 10.1631 18.6168 10.9331V22.1331C18.6168 22.9031 17.9868 23.5331 17.2168 23.5331C16.4468 23.5331 15.8168 22.9031 15.8168 22.1331V10.9331C15.8168 10.1631 16.4468 9.53308 17.2168 9.53308ZM22.8168 17.5331C23.5868 17.5331 24.2168 18.1631 24.2168 18.9331V22.1331C24.2168 22.9031 23.5868 23.5331 22.8168 23.5331C22.0468 23.5331 21.4168 22.9031 21.4168 22.1331V18.9331C21.4168 18.1631 22.0468 17.5331 22.8168 17.5331Z",
    fill: "#4318FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_280_6660"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.37207,
    y: 0.452148,
    width: 23.2833,
    height: 24.6783,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_280_6660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(5.2168 4.53308)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButton);
export default __webpack_public_path__ + "static/media/Button.5b735a340ccb857f3d85f29a39acae34.svg";
export { ForwardRef as ReactComponent };